export const environment = {
  production: false,
  apiUrl: 'https://test.lagunabay.eskspatial.com.au/api/v1/',
  hubUrl: '',
  version: '',
  appPrefix: 'lb',
} as const;
